export const SET_STOCKS = 'stocks/set-stocks'
